module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(!model.dialogText && model.dialogTextKey){\nmodel.dialogText = storage.__(model.dialogTextKey)\n}\n%><div>\n<%- helpers.renderSection('onTopContent'); %>\n<section class=\"content\">\n<% if(model.dialogText){ %>\n<p><%= model.dialogText %></p>\n<% } %>\n<%- helpers.renderSection(); %>\n</section>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\credentials\\container.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(!model.dialogText && model.dialogTextKey){
model.dialogText = storage.__(model.dialogTextKey)
}

    ; __line = 5
    ; __append("<div>\n")
    ; __line = 6
    ; __append( helpers.renderSection('onTopContent') )
    ; __append("\n<section class=\"content\">\n")
    ; __line = 8
    ;  if(model.dialogText){ 
    ; __append("\n<p>")
    ; __line = 9
    ; __append(escapeFn( model.dialogText ))
    ; __append("</p>\n")
    ; __line = 10
    ;  } 
    ; __append("\n")
    ; __line = 11
    ; __append( helpers.renderSection() )
    ; __append("\n</section>\n</div>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\credentials\container.ejs

}